// src/services/formService.js
import {
  getForms,
  getFormById,
  createForm,
  updateForm,
  deleteForm,
  getFormSubmissions,
  getSubmissionById,
  submitForm,
  deleteSubmission,
  submitSharedForm,
  getSharedForm,
  verifyFormPassword,
  shareForm,
  getFormShares,
  updateFormShare,
  deleteFormShare,
  updateSubmissionStatus,
  getSubmissionFileUploadUrl,
  getPublicSubmissionFileUploadUrl,
  exportFormSubmissions,
  getFormAnalytics
} from './formService.impl';

/**
 * Service for handling form-related operations
 * This is now a wrapper around the standardized implementation in formService.impl.js
 */
const formService = {
  getForms,
  getFormById,
  createForm,
  updateForm,
  deleteForm,
  getFormSubmissions,
  getSubmissionById,
  submitForm,
  deleteSubmission,
  submitSharedForm,
  getSharedForm,
  verifyFormPassword,
  shareForm,
  getFormShares,
  updateFormShare,
  deleteFormShare,
  updateSubmissionStatus,
  getSubmissionFileUploadUrl,
  getPublicSubmissionFileUploadUrl,
  exportFormSubmissions,
  getFormAnalytics
};

export default formService;